module.exports = __webpack_public_path__ + "img/zig-zag.8034a4fb.png";